var DONEGDPRParams = {
    color: '#D9BB93',
    lang: jQuery('html').attr('lang').substr(0, 2),
    policy_url: ajax.cookie_policy_url,
    groups: {
        always_active: [{
            name: 'Google (NID, CONSENT, P_JAR, HSID, APISID, SAPISID, SID, SIDCC, SSID)'
        }, {
            name: 'pestvarmegyeimustra.hu saját sütijei (PHPSESSID, DONEGDPRConsent, DONEGDPRAlertBoxClosed, menu_type)'
        }],
        targeting: [{
            name: 'Facebook (fr, _fbp)'
        }]
    }
};
if (ajax.ga_tag !== '') {
    DONEGDPRParams.groups['performance'] = [{ name: 'Google Analytics (_ga, _gat, _gid)', }];
}

(function ($) {
    $(() => {

        jQuery.event.special.touchstart = {
            setup: function (_, ns, handle) {
                this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        jQuery.event.special.touchmove = {
            setup: function (_, ns, handle) {
                this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        jQuery.event.special.wheel = {
            setup: function (_, ns, handle) {
                this.addEventListener("wheel", handle, { passive: true });
            }
        };
        jQuery.event.special.mousewheel = {
            setup: function (_, ns, handle) {
                this.addEventListener("mousewheel", handle, { passive: true });
            }
        };

        $.cookieSettings = Cookies.get('DONEGDPRConsent');

        if ($.cookieSettings != undefined) {
            $.cookieSettings = JSON.parse($.cookieSettings);
        }

        if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
                if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                n.queue = []; t = b.createElement(e); t.async = !0;
                t.src = v; s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '306903799983347');
            fbq('track', 'PageView');
        }

        if (ajax.ga_tag !== '') {
            var disable_text = 'ga-disable-' + ajax.ga_tag;
            if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
                window[disable_text] = false;

                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }

                gtag('js', new Date());
                gtag('config', ajax.ga_tag);
            } else {
                window[disable_text] = true;
                var cookies = Cookies.get();
                if ('' !== cookies) {

                    $.each(cookies, function (index) {
                        index = '' + index;

                        if ('_ga' === index || '_gid' === index || '_gat' === index) {
                            Cookies.remove(index, { domain: document.domain });
                            Cookies.remove(index, { domain: document.domain.substr(document.domain.indexOf(".")) });
                        }
                    });
                }
            }
        }

        $(document).on('click', '.js-open-cookie a', function (e) {
            e.preventDefault();
            cookiedone.showCookieSettings();

            if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
                $('.done-gdpr-status-checkbox.performance').attr('checked', true)
            }
            if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
                $('.done-gdpr-status-checkbox.functional').attr('checked', true)
            }
            if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
                $('.done-gdpr-status-checkbox.targeting').attr('checked', true)
            }
        });

        $(document).on('click', '#done-gdpr-save-button', function (e) {
            location.reload();
        });

        $(document).on('click', '.done-gdpr-button-allow', function (e) {
            e.preventDefault();
            e.stopPropagation();
            cookiedone.allowAll();
            location.reload();
        });

        $('.js-hero-slider').slick({
            arrows: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            cssEase: 'linear'
        });

        //gallery
        $('.html5-videos').lightGallery({

        });

        $('.more-posts-slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.up-inf').hover(function () {
            $('.uploads-info-text-wrapper').toggleClass('show');
        });


        if ($(".anim-number-page").length > 0) {
            $(window).scroll(function () {
                var offset = 500;
                if ($(window).width() <= 768) {
                    offset = 0;
                }
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(".number-wrapper").offset().top + offset;


                if (pageBottom > elementTop) {

                    $('.number-to-anim').each(function () {
                        var $this = $(this);

                        if ($this.hasClass('duringanim')) {
                            return;
                        }


                        var number = $this.text();
                        var rest = "";
                        if ($this.text().indexOf(' ') > 0) {
                            number = $this.text().substr(0, $this.text().indexOf(' '));
                            rest = " " + $this.text().substr($this.text().indexOf(" ") + 1);
                        }

                        $this.addClass('duringanim');
                        $({ Counter: 0 }).animate({ Counter: number }, {
                            duration: 3000,
                            easing: 'swing',
                            step: function () {
                                if ($this.hasClass("fraction")) {


                                    if ((this.Counter).toFixed(2) == number && number.substr(number.length - 2) == "0") {
                                        var fixed_text = number.substr(0, number.length - 2) + rest;
                                        $this.text(fixed_text);
                                    }
                                    else {
                                        $this.text((this.Counter).toFixed(2) + rest);
                                    }

                                }
                                else {
                                    $this.text(Math.ceil(this.Counter) + rest);
                                }
                            },

                            complete: function () {
                                $this.removeClass('duringanim');
                                $this.removeClass('number-to-anim');
                            }
                        });
                    });
                }
            });
        }

        $('.searching').on('click', function () {
            $('.search-wrapper').toggleClass('show');
            $('.header-navbar').toggleClass('hide');
            $('.hamburger').toggleClass('search-opened');
            $(this).toggleClass('active');
        });

        if ($('.search-input').val() !== '') {
            $('.search-wrapper').toggleClass('show');
            $('.header-navbar').toggleClass('hide');
            $('.searching').toggleClass('active');
            $('.hamburger').toggleClass('search-opened');
        }

        $('.open-gallery-div').on('click', function () {
            var id = $(this).attr('id');
            $('[data-image="' + id + '"]').trigger('click');
        });

        AOS.init();

    });
})(jQuery);
